import HARDCODE from '../../../business-const/HardCode/HardCode'



export const informouConsideracoesFinais = (values) => {

    let informou = false

    values.consideracaoFinal?.forEach( (linhaConsideracaoFinal, indexConsideracaoFinal) => {

        if (linhaConsideracaoFinal.richText && linhaConsideracaoFinal.richText !== HARDCODE.richTextEditorVazio) {

            informou = true
        }
    })

    return informou
}